
import { RevIllustration, RevLink } from '@backmarket/design-system'
import { camelizeKeys } from 'humps'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { PayWithRest } from '@payment'

import translations from './SellerBlock.translations'

export default {
  components: {
    RevLink,
    RevIllustration,
    PayWithRest,
  },
  props: {
    grade: {
      type: Object,
      default: () => ({}),
    },
    seller: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    ...mapGetters({
      countryPaymentMethods: 'countryConfig/paymentMethods',
    }),

    paymentMethods() {
      return isEmpty(this.grade.paymentMethods)
        ? this.countryPaymentMethods
        : camelizeKeys(this.grade.paymentMethods)
    },
  },
}
